/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* sihwsemaphore.ts
* 23-3-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Injectable} from '@angular/core';
import {Sihwlog, Sihwlogger} from '../sihwlog/sihwlog';

interface lock  { promise: Promise<void>,resolver: () => void}

@Injectable()
export class Sihwsemaphore {
  private log?: Sihwlogger;

  /**
   * Locks zijn resolvers op locknaam. Dus geen eigenaarscontrole: als je waitLock doet, moet je unlock doen. Als je geen waitLock doet, mag je geen unlock doen.
   */

  private locks: Map<string, lock> = new Map();

  /**
   * Construct de semaphore, eventueel met logging
   * @param sihwLog
   */
  constructor(sihwLog?: Sihwlog) {
    if (sihwLog) {
      this.log = sihwLog.logger(); //default
    }
  }

  public async waitLock(lock: string): Promise<void> {
    if (this.locks.has(lock))
    {
      this.log?.debug(`Sihwsemaphore: waitlock ${lock}`);
      await (<lock>this.locks.get(lock)).promise; //wacht tot er ruimte is
      //en dan kijken of we de eerste waren
      return this.waitLock(lock);
    }
    else {
      //zet de lockdata in de closure, dan kan de promise executor de resolver zetten

      let resolver: any;
      let promise: Promise<void> = new Promise((resolve, _reject) => {
        resolver = resolve; //hebbes
      });
      this.locks.set(lock, {promise: promise, resolver: resolver});
      this.log?.debug(`Sihwsemaphore: ${lock} verkregen`);
      return; //het is geregeld. Unlock doet de resolve
    }
  }

  /**
   * Unlock een verkregen lock. Heel simpel: geen controle
   * @param lock
   */
  public unlock(lock:string): void {
    if (this.locks.has(lock))
    {
      let lockdata = <lock> this.locks.get(lock);
      this.locks.delete(lock);
      this.log?.debug(`Sihwsemaphore: unlock ${lock}`);
      lockdata.resolver(); //en laten weten dat de lock vrij is
    }
    else {
      this.log?.warn(`Sihwsemaphore: unlock unknown lock ${lock}`);
    }
  }
}
